import React, { useEffect, useMemo, useState } from "react";
import NodeNameValidation from "../../atoms/node-name-validation";
import { cloneDeep } from "lodash";
import { Col, Form, FormGroup, Input, Label, Row, Card } from "reactstrap";
import HelpTooltip from "../../atoms/help-tooltip";
import { t } from "../../../utils/utils";
import T from "../../atoms/translate";
export default function NodeReturnProperty({ node, nodeChange, dependencies }) {
  const outputs = useMemo(() => {
    if (dependencies.context) {
      const tmp = [];
      dependencies.context.forEach(o => {
        Object.entries(o.exported).forEach(([key, value]) => {
          tmp.push({
            name: key,
            nodeFrom: o.node,
            type: Array.isArray(value) ? "model" : value.type
          });
        });
      });
      return tmp;
    }
    return [];
  }, [dependencies.context]);
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [fromNode, setFromNode] = useState("");
  const [index, setIndex] = useState("");
  useEffect(() => {
    const { args } = node.properties;
    if (args && args.inputData) {
      const tmp = Object.entries(node.properties.args.inputData).map(
        ([key, value]) => ({
          //se guarda los valores del inputData actual
          name: key,
          type: value.type,
          nodeFrom: value.from
        })
      )[0];
      setName(tmp.name);
      setType(tmp.type);
      setFromNode(tmp.nodeFrom);
      setIndex(
        outputs.findIndex(
          o => o.name === tmp.name && o.nodeFrom === tmp.nodeFrom
        )
      );
    }
  }, [node, outputs]);
  const onChangeOutput = ({ target }) => {
    const value = [].filter
      .call(target.options, o => o.selected)
      .map(o => o.value)[0];
    if (value) {
      const tmpOut = outputs[value];
      setName(tmpOut.name);
      setIndex(value);
      setFromNode(tmpOut.nodeFrom);
      setType(tmpOut.type);
    }
  };
  const findReturnType = (name, type) => {
    const { changeQuantifier } = dependencies;
    if (type === "model" || type === "array") {
      if (type === "array") {
        changeQuantifier("many");
        return name;
      } else {
        changeQuantifier("one");
        return name;
      }
    }
    changeQuantifier("one");
    return type;
  };
  const onSubmit = nodeName => {
    const tmp = cloneDeep(node);
    tmp.properties.name = nodeName;
    if (name && type && fromNode) {
      tmp.properties.args = {
        type: findReturnType(name, type),
        inputData: { [name]: { type: type, from: fromNode } }
      };
    }
    nodeChange(tmp);
  };
  return (
    <>
      <NodeNameValidation
        label={t("modalPropiedadesLabelNodoValidacionNombre")}
        feedback={t("modalPropiedadesFeedbackValidacionNombre")}
        nodesNames={dependencies.nodeNames}
        oldName={node.properties.name}
        onSubmit={onSubmit}
      />
      <Card body className="border-0 box-shadow mb-4">
        <Row>
          <Col xs="12">
            <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
              <T i18nKey="modalPropiedadesRetornoTitulo" />
            </h1>
          </Col>
          <Col xs="12">
            <Form>
              <Row form>
                <Col md={4}>
                  <FormGroup>
                    <Label for="nameInput">
                      <T i18nKey="modalPropiedadesRetornoContexto" />{" "}
                      <HelpTooltip
                        msg={t("modalPropiedadesRetornoContextoTooltip")}
                      />
                    </Label>
                    <Input
                      id="nameInput"
                      type="select"
                      onChange={onChangeOutput}
                      value={index}
                    >
                      <option value={null} />
                      {outputs.map((o, key) => (
                        <option value={key} key={key}>
                          {o.name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      <T i18nKey="modalPropiedadesRetornoTipo" />{" "}
                      <HelpTooltip
                        msg={t("modalPropiedadesRetornoTipoTooltip")}
                      />
                    </Label>
                    <Input
                      value={type}
                      onChange={e => setType(e.target.value)}
                      disabled
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      <T i18nKey="modalPropiedadesRetornoPadre" />{" "}
                      <HelpTooltip
                        msg={t("modalPropiedadesRetornoPadreTooltip")}
                      />
                    </Label>
                    <Input
                      value={fromNode}
                      onChange={e => setFromNode(e.target.value)}
                      disabled
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
    </>
  );
}
